import { CheckIcon } from "@radix-ui/react-icons";
import { Flex, Link, Table as ReactTable, Text } from "@radix-ui/themes";

interface Scholarship {
  name: string;
  link: string;
  fixedWingBasic: boolean;
  fixedWingAdvance: boolean;
  airExperience: boolean;
  helicopter: boolean;
  gliding: boolean;
  airsports: boolean;
  drone: boolean;
}

const Table: React.FC<{
  scholarshipType: string;
  scholarships: Scholarship[];
}> = ({ scholarshipType, scholarships }) => {
  return (
    <ReactTable.Root variant="surface" layout="fixed">
      <ReactTable.Header>
        <ReactTable.Row align="center">
          <ReactTable.ColumnHeaderCell width="69%"></ReactTable.ColumnHeaderCell>
          <ReactTable.ColumnHeaderCell justify="center">
            {scholarshipType}
          </ReactTable.ColumnHeaderCell>
        </ReactTable.Row>
      </ReactTable.Header>

      <ReactTable.Body>
        {scholarships.map((scholarship) => {
          return (
            <ReactTable.Row key={scholarship.name} align="center">
              <ReactTable.RowHeaderCell>
                <Link
                  href={scholarship.link}
                  color="gray"
                  target="_blank"
                  highContrast
                >
                  <Flex>
                    <Text as="span" size="2" wrap="balance">
                      {scholarship.name}
                    </Text>
                  </Flex>
                </Link>
              </ReactTable.RowHeaderCell>
              <ReactTable.Cell>
                <Flex justify="center">
                  <CheckIcon color="green" />
                </Flex>
              </ReactTable.Cell>
            </ReactTable.Row>
          );
        })}
      </ReactTable.Body>

      <ReactTable.Header>
        <ReactTable.Row align="center">
          <ReactTable.ColumnHeaderCell
            style={{
              boxShadow: "unset",
              borderTop: "1px solid var(--gray-a5)",
            }}
          ></ReactTable.ColumnHeaderCell>
          <ReactTable.ColumnHeaderCell
            justify="center"
            style={{
              boxShadow: "unset",
              borderTop: "1px solid var(--gray-a5)",
            }}
          >
            {scholarshipType}
          </ReactTable.ColumnHeaderCell>
        </ReactTable.Row>
      </ReactTable.Header>
    </ReactTable.Root>
  );
};

export default Table;
